// Phase 84.M.34 — API wrapper cho self rating verification.
import { api } from "./api";

export async function analyzeRatingScreenshot(images, onUploadProgress) {
  const r = await api.post("/athlete/rating-verification/analyze", { images }, {
    onUploadProgress: (e) => {
      if (e?.total && typeof onUploadProgress === "function") {
        onUploadProgress(Math.round((e.loaded / e.total) * 100));
      }
    },
    // OCR có thể chạy ~10-30s ở upstream.
    timeout: 120_000,
  });
  return r.data;
}

export async function submitRatingVerification(payload, onUploadProgress) {
  const r = await api.post("/athlete/rating-verification/submit", payload, {
    onUploadProgress: (e) => {
      if (e?.total && typeof onUploadProgress === "function") {
        onUploadProgress(Math.round((e.loaded / e.total) * 100));
      }
    },
    timeout: 60_000,
  });
  return r.data;
}

export async function listMyRatingRequests() {
  const r = await api.get("/athlete/rating-verification/me");
  return r.data;
}

export async function adminListRatingVerifications(params = {}) {
  const r = await api.get("/admin/rating-verifications", { params });
  return r.data;
}

export async function adminGetRatingVerification(id) {
  const r = await api.get(`/admin/rating-verifications/${id}`);
  return r.data;
}

export async function adminApproveRatingVerification(id, body) {
  const r = await api.patch(`/admin/rating-verifications/${id}/approve`, body);
  return r.data;
}

export async function adminRejectRatingVerification(id, body) {
  const r = await api.patch(`/admin/rating-verifications/${id}/reject`, body);
  return r.data;
}

// Phase 90.I — Bỏ qua VĐV không phản hồi duyệt điểm.
export async function adminSkipRatingVerification(id, body = {}) {
  const r = await api.patch(`/admin/rating-verifications/${id}/skip`, body);
  return r.data;
}

// v17.89 (Feb 2026) — Append 1 admin-only note vào timeline của request.
// Không hỗ trợ xoá/sửa (audit trail).
export async function adminAppendRatingVerificationNote(id, body) {
  const r = await api.post(`/admin/rating-verifications/${id}/notes`, body);
  return r.data;  // { note: {...}, notes: [...] }
}


export async function adminGetRatingVerificationSettings() {
  const r = await api.get("/admin/rating-verifications/settings");
  return r.data;
}

export async function adminPatchRatingVerificationSettings(body) {
  const r = await api.patch("/admin/rating-verifications/settings", body);
  return r.data;
}

// Helper: convert file → base64 (no data URL prefix).
export async function fileToBase64NoPrefix(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;
      if (typeof dataUrl !== "string") {
        reject(new Error("Read failed"));
        return;
      }
      const comma = dataUrl.indexOf(",");
      resolve({ data: dataUrl.slice(comma + 1), mime: file.type || "image/jpeg" });
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
